{
  "journalAudit.action.org.agent.draft_deleted": "Brouillon d’un agent de l’organisation supprimé"
}
